<template>
  <div>
    <form @submit.prevent="saveOnboarding">


      <CRow class="mt-3 mb-3">
        <CCol
          tag="label"
          sm="3"
          class="col-form-label">
          Название
        </CCol>
        <CCol sm="9">
          <input
            id="title"
            v-model="onboarding.title"
            type="text"
            class="form-control"
            required
          />
        </CCol>
      </CRow>

      <CRow class="mt-3 mb-3">
        <CCol
          tag="label"
          sm="3"
          class="col-form-label">
          Сортировка
        </CCol>
        <CCol sm="9">
          <input
            id="sort"
            v-model="onboarding.sort"
            type="text"
            class="form-control"
            required
          />
        </CCol>
      </CRow>

      <CRow class="mt-3 mb-3">
        <CCol
          tag="label"
          sm="3"
          class="col-form-label">
          Количество показов
        </CCol>
        <CCol sm="9">
          <input
            id="limit_show_count"
            v-model="onboarding.limit_show_count"
            type="number"
            class="form-control"
            required
          />
        </CCol>
      </CRow>
      <br>
      <p style="font-size: 10px; color: #4d5b72;">
        Если главная страница то "/", если рестораны то "/restaurant" или другие сервисы "/entity/assist/drugoe-poruchenie"
      </p>

      <CRow class="mt-1 mb-3">
        <CCol
          tag="label"
          sm="3"
          class="col-form-label">
          Страница показа
        </CCol>
        <CCol sm="9">
          <input
            id="router"
            v-model="onboarding.router"
            type="text"
            class="form-control"
            required
          />
        </CCol>
      </CRow>

      <div class="overflow-hidden border border-gray-300 rounded-md p-2 mb-3">
        <CRow>
          <CCol
            tag="label"
            sm="3"
            class="col-form-label">
            Показывать попап банер
          </CCol>
          <CCol sm="9">
            <CSwitch
              color="success"
              shape="pill"
              variant="opposite"
              :checked.sync="onboarding.show_banner"
            />
          </CCol>
        </CRow>

        <CRow class="mt-3" v-show="onboarding.show_banner">
          <CCol
            tag="label"
            sm="3"
            class="col-form-label">
            Изображение для банера
          </CCol>
          <CCol sm="9">
            <div v-if="onboarding.image">
              <img
                :src="getImageUrl(onboarding.image)"
                alt="Current Image"
                class="current-image"
              />
            </div>
            <input
              type="file"
              @change="selectImage"
              class="form-control-file"
            />
          </CCol>
        </CRow>
      </div>

      <CRow
        form class="form-group">
        <CCol
          tag="label"
          class="col-form-label">Тип пагинации</CCol>
        <CCol sm="9">
          <CSelect
            inline
            :value.sync="onboarding.pagination"
            :options="paginations"
            placeholder="Тип пагинации"
          />
        </CCol>
      </CRow>

      <CRow
        form class="form-group">
        <CCol
          tag="label"
          class="col-form-label">Каким клиентам показывать</CCol>
        <CCol sm="9">
          <CSelect
            inline
            :value.sync="onboarding.client_type"
            :options="client_types"
            placeholder="Кому показывать"
          />
        </CCol>
      </CRow>

      <CRow class="mb-3">
        <CCol
          tag="label"
          sm="3"
          class="col-form-label">
          Включен
        </CCol>
        <CCol sm="9">
          <CSwitch
            color="success"
            shape="pill"
            variant="opposite"
            :checked.sync="onboarding.enabled"
          />
        </CCol>
      </CRow>

      <div class="overflow-hidden border border-gray-300 rounded-md p-2 mb-3">
        <CRow class="mt-2">
          <CCol tag="label" sm="3" class="col-form-label">Показать опрос после онбординга</CCol>
          <CCol sm="9">
            <CSwitch
              color="success"
              shape="pill"
              variant="opposite"
              :checked.sync="onboarding.show_survey_after"
            />
          </CCol>
        </CRow>

        <CRow class="mt-3" v-if="onboarding.show_survey_after">
          <CCol tag="label" sm="3" class="col-form-label">Опрос после онбординга</CCol>
          <CCol sm="9">
            <CSelect
              inline
              :value.sync="onboarding.post_survey_id"
              :options="surveyOptions"
              placeholder="Выберите опрос"
            />
            <div v-if="surveyValidationError" class="text-danger mt-1" style="font-size:12px;">{{ surveyValidationError }}</div>
          </CCol>
        </CRow>

        <!-- A/B перенесено в общий раздел А/B тестирования -->
      </div>
      
      <CRow class="mb-3">
        <CCol tag="label" sm="3" class="col-form-label" for="parent-promocode">
          Родительский промокод
        </CCol>
        <CCol sm="9">
          <select
            id="parent-promocode"
            v-model="onboarding.parent_promocode_id"
            class="form-control"
            :disabled="isLoadingPromocodes"
          >
            <option :value="null">Без подарочного промокода</option>
            <option v-for="option in promocodeOptions" :key="option.value" :value="option.value">
              {{ option.label }}
            </option>
          </select>
          <small class="form-text text-muted">
            Создайте промокод на бесплатную доставку в разделе «Промокоды» и выберите его здесь.
            Срок в днях и число применений берутся из родительского промокода.
          </small>
          <small v-if="selectedPromocode" class="form-text">
            Срок с момента выдачи: {{ selectedPromocode.term_day }} дн.
            Число применений: {{ selectedPromocode.term_count }}.
          </small>
          <router-link v-if="onboarding.parent_promocode_id" :to="`/promocodes/${onboarding.parent_promocode_id}`">
            Открыть родительский промокод
          </router-link>
          <div v-if="isLoadingPromocodes" class="text-muted mt-1">Загрузка промокодов…</div>
          <div v-if="promocodeLoadError" class="text-danger mt-1" role="alert">
            {{ promocodeLoadError }}
            <button type="button" class="btn btn-link p-0" @click="loadPromocodes">Повторить</button>
          </div>
          <div v-if="promocodeValidationError" class="text-danger mt-1" role="alert">{{ promocodeValidationError }}</div>
        </CCol>
      </CRow>

      <button type="submit" class="btn btn-primary">
        Сохранить
      </button>
    </form>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';

export default {
  props: {
    onboarding: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      selectedImage: null,
      surveys: [],
      surveyValidationError: '',
      promocodes: [],
      isLoadingPromocodes: false,
      promocodeLoadError: '',
      promocodeValidationError: '',
      client_types: [
        { value: null, label: 'Всем' },
        { value: 1, label: 'Только новым' },
        { value: 2, label: 'Только старым' }
      ],
      paginations: [
        { value: null, label: 'Отключена' },
        { value: 1, label: 'Сверху' },
        { value: 2, label: 'Снизу' }
      ],
    };
  },

  computed: {
    selectedPromocode() {
      return this.promocodes.find(promocode => promocode.id === Number(this.onboarding.parent_promocode_id));
    },
    promocodeOptions() {
      const options = this.promocodes
        .filter(promocode => this.checkParentPromocode(promocode) || promocode === this.selectedPromocode)
        .map(promocode => ({
          value: promocode.id,
          label: `${promocode.code} #${promocode.id}${this.checkParentPromocode(promocode) ? '' : ' (недоступен для выдачи)'}`,
        }));
      if (this.onboarding.parent_promocode_id && !this.selectedPromocode) {
        options.unshift({ value: Number(this.onboarding.parent_promocode_id), label: `#${this.onboarding.parent_promocode_id} (не загружен или удалён)` });
      }
      return options;
    },
    surveyOptions() {
      return [
        { value: null, label: '—' },
        ...this.surveys.map(s => ({ value: s.id, label: `${s.title} ${s.enabled ? '' : '(выкл.)'}` }))
      ];
    }
  },

  async mounted() {
    if (this.onboarding.parent_promocode_id === undefined) {
      this.$set(this.onboarding, 'parent_promocode_id', null);
    }
    this.loadPromocodes();
    try {
      const { data } = await Vue.axios.get('/surveys?pageSize=1000');
      this.surveys = Array.isArray(data) ? data : (data?.results || []);
    } catch (e) {
      // ignore
    }
  },

  methods: {
    checkParentPromocode(promocode) {
      const now = moment();
      return !!promocode && !promocode.deleted && !!promocode.enabled &&
        !promocode.customer_id && !promocode.parent_id && !!promocode.free_delivery &&
        !promocode.for_discount_on_orders &&
        Number.isInteger(promocode.term_day) && promocode.term_day > 0 &&
        Number.isInteger(promocode.term_count) && promocode.term_count > 0 &&
        (!promocode.date_start || !now.isBefore(moment(promocode.date_start))) &&
        (!promocode.date_finish || now.isBefore(moment(promocode.date_finish)));
    },
    async loadPromocodes() {
      this.isLoadingPromocodes = true;
      this.promocodeLoadError = '';
      try {
        const promocodes = [];
        let page = 1;
        let total;
        do {
          const { data } = await Vue.axios.get('/promocodes', { params: { page, pageSize: 500 } });
          if (!Array.isArray(data.results) || !Number.isFinite(data.total)) {
            throw new Error('Invalid promocode list');
          }
          promocodes.push(...data.results);
          total = data.total;
          if (!data.results.length && promocodes.length < total) {
            throw new Error('Incomplete promocode list');
          }
          page += 1;
        } while (promocodes.length < total);
        this.promocodes = promocodes;
      } catch (error) {
        this.promocodeLoadError = 'Не удалось загрузить промокоды. Текущий выбор сохранён.';
      } finally {
        this.isLoadingPromocodes = false;
      }
    },
    async saveOnboarding() {
      try {
        this.promocodeValidationError = '';
        if (this.onboarding.parent_promocode_id && !this.promocodeLoadError &&
          (this.isLoadingPromocodes || !this.checkParentPromocode(this.selectedPromocode))) {
          this.promocodeValidationError = this.isLoadingPromocodes
            ? 'Дождитесь загрузки промокодов'
            : 'Выберите активный родительский промокод на бесплатную доставку с положительными сроком в днях и числом применений';
          return;
        }
        this.surveyValidationError = '';
        if (this.onboarding.show_survey_after && !this.onboarding.post_survey_id) {
          this.surveyValidationError = 'Выберите опрос';
          return;
        }
        if (this.selectedImage) {
          let formData = new FormData();
          formData.append('file', this.selectedImage);
          const uploadResponse = await Vue.axios.post('/files/upload', formData);
          this.onboarding.image = uploadResponse.data.filename;
        }

        const saveData = {
          title: this.onboarding.title,
          sort: +this.onboarding.sort,
          limit_show_count: +this.onboarding.limit_show_count,
          router: this.onboarding.router,
          enabled: !!this.onboarding.enabled,
          image: this.onboarding.image,
          show_banner: !!this.onboarding.show_banner,
          client_type: this.onboarding.client_type,
          pagination: this.onboarding.pagination,
          show_survey_after: !!this.onboarding.show_survey_after,
          post_survey_id: this.onboarding.post_survey_id ? +this.onboarding.post_survey_id : null,
          parent_promocode_id: this.onboarding.parent_promocode_id ? Number(this.onboarding.parent_promocode_id) : null,
        };

        this.$emit('save', saveData);
      } catch (error) {
        console.log(error, 'error');
        
        this.$root.$emit('showError', 'Ошибка загрузки изображения.');
      }
    },
    selectImage(event) {
      this.selectedImage = event.target.files[0];
    },
    getImageUrl(filename) {
      return process.env.VUE_APP_STATIC_BASE_URL + '/' + filename;
    },
  },
};
</script>
<style scoped>
.current-image {
  max-width: 200px;
  max-height: 200px;
  margin-bottom: 10px;
}
</style>
